// Contact.tsx
import contactImage from "../../../assets/blogImages/4.jpeg";
import GoogleFormEmbed from "./GoogleFormEmbed ";

const Contact = () => {
  return (
    <section className="relative w-full h-screen bg-bg-primary overflow-hidden">
      <div className="grid lg:grid-cols-2 h-full">

        {/* LEFT IMAGE / BRAND PANEL */}
        <div className="relative hidden lg:flex items-center overflow-hidden h-full">

          {/* Background Image */}
          <img
            src={contactImage}
            alt="Medical-grade 3D manufacturing process"
            className="absolute inset-0 h-full w-full object-cover scale-105"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/55 to-black/20" />

          {/* Ambient Glow */}
          <div className="absolute -top-32 -left-32 w-[480px] h-[480px] bg-primary/25 blur-[160px] rounded-full" />

          {/* Vertical Accent */}
          <div className="absolute left-20 top-1/2 -translate-y-1/2 h-[60%] w-px bg-primary/50" />

         {/* Content */}
<div className="absolute bottom-1 right-16 z-10 text-right text-white">
  <span
    className="inline-flex items-center gap-2 mb-6 text-[11px] tracking-widest uppercase
    border border-primary/40 text-primary/90 px-4 py-1.5 rounded-full"
  >
    Scan • Create • Print
  </span>

  <div className="ml-auto mt-8 h-12 w-px bg-primary/70" />
</div>

        </div>

        {/* RIGHT FORM PANEL */}
        <div className="relative flex items-center justify-center h-full px-4 sm:px-6 lg:px-12">

          {/* Soft background texture */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(0,0,0,0.04),_transparent_70%)] pointer-events-none" />

          {/* Form container (scrollable only inside) */}
          <div className="relative w-full max-w-2xl h-[calc(100vh-96px)] overflow-hidden">
            <div className="h-full overflow-y-auto rounded-2xl">
              <GoogleFormEmbed />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
